export interface IHistoryItem {
  time: string;
  action: string;
}

export interface IHistory {
  date: string;
  records: IHistoryItem[];
}
